import React, { useEffect } from "react";
import { Box, Typography } from "@mui/material";

import Banner from "./Banner";
import ContainerTemplate from "./ContainerTemplate";
import HowHelp from "./HowHelp";
import HowWork from "./HowWork";
import HaveQuestions from "../../components/HaveQuestions";

// DAM Discovery Framework Container Icons
import InboxOutlinedIcon from "@mui/icons-material/InboxOutlined";
import AnalyticsOutlinedIcon from "@mui/icons-material/AnalyticsOutlined";
import CheckCircleOutlinedIcon from "@mui/icons-material/CheckCircleOutlined";
import EditNoteOutlinedIcon from "@mui/icons-material/EditNoteOutlined";

// Banner
import bgImage from "../../assets/damDiscovery.png";
const bannerTitle = "DAM Discovery Framework";
const bannerDesc =
  "A structured methodology designed to capture your current DAM processes, challenges, and requirements—laying the foundation for the right solution.";

// DAM Discovery Framework Container
const discoveryTitle = "DAM Discovery Framework";
const discoveryDesc =
  "We bridge the common disconnect between discovery and recommendation. By using our structured framework to capture your current as-is processes with precision, we ensure that our final recommendations align perfectly with your actual needs.";
const discoveryCards = [
  {
    title: "Capture",
    description: "Gather current workflows, tools, and stakeholder inputs.",
    icon: InboxOutlinedIcon,
  },
  {
    title: "Analyze",
    description: "Identify gaps, inefficiencies, and opportunities.",
    icon: AnalyticsOutlinedIcon,
  },
  {
    title: "Define",
    description: "Translate insights into functional & technical requirements.",
    icon: EditNoteOutlinedIcon,
  },
  {
    title: "Validate",
    description: "Confirm requirements with stakeholders to ensure completeness.",
    icon: CheckCircleOutlinedIcon,
  },
];

const PracticePage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box sx={{ backgroundColor: "#F9F9F9" }}>
      <Box /*sx={{ maxWidth: "1440px" }}*/>
        <Banner title={bannerTitle} description={bannerDesc} image={bgImage} />
        <ContainerTemplate
          title={discoveryTitle}
          description={discoveryDesc}
          cardsData={discoveryCards}
        />
        <HowHelp />
        <HowWork />
        {/* Have Questions Section */}
        <HaveQuestions />
      </Box>
    </Box>
  );
};

export default PracticePage;
